import * as types from '../../action-types';
import {deleteLanguage as initialState } from "../../initialState";

const deleteLanguage = (state=initialState, action) => {
  switch (action.type) {
    case types.DELETE_LANGUAGE_START:
      return {
        ...state,
        isLoading: true
      };
    case types.DELETE_LANGUAGE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        data: action.payload
      };
    case types.DELETE_LANGUAGE_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    case types.DELETE_LANGUAGE_CLEANUP:
      return {
        ...state,
        isLoading: false,
        isSuccessful: false,
        error: null
      };
    default:
      return state;
  }
}

export default deleteLanguage;
